import(/* webpackMode: "eager", webpackExports: ["PageClientComponent"] */ "/app/src/app/[locale]/components/page-client-component/component.tsx");
